export default "__VITE_ASSET__2bfc98b8__"